const navbar = document.querySelector("nav");
const scrollThreshold = 200;
function updateScrollState() {
// if the page has been scrolled past the threshold, add a tint to the navbar
// navbar.classList.toggle("tinted", window.scrollY > scrollThreshold);
}
// add/remove tint on initialization
updateScrollState();
// add/remove tint on scroll
window.addEventListener("scroll", updateScrollState);

//# sourceMappingURL=2a8aebea.js.map
